/**
 * External dependencies
 */
import React, { useState } from "react";
import { Stack } from "@towersystems/towersystems-design-system";
import { map, noop } from "lodash";

/**
 * Internal dependencies
 */
import FormCheckbox from "components/forms/form-checkbox";

/**
 * Style dependencies
 */
import "./styles.scss";

const FormMultiCheckbox = ({
  defaultChecked = [],
  options,
  name = "multiCheckbox",
  onChange = noop,
}) => {
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = (event) => {
    const target = event.target;
    let changeEventValue = [...checked];

    changeEventValue = changeEventValue
      .concat([target.value])
      .filter((currentValue) => {
        return currentValue !== target.value || target.checked;
      });

    if (onChange) {
      onChange(changeEventValue);
    }

    setChecked(changeEventValue);
    event.stopPropagation();
  };

  return (
    <Stack space="large">
      {map(options, (option) => (
        <FormCheckbox
          key={option.value}
          name={name + "[]"}
          onChange={handleChange}
          checked={checked.includes(option.value)}
          label={option.label}
          value={option.value}
        />
      ))}
    </Stack>
  );
};

export default FormMultiCheckbox;
